module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "nav-button",
    style: ({
      textAlign: _vm.align
    }),
    on: {
      "click": function($event) {
        _vm.$emit('onClick')
      }
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4035b7ca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavButton.vue
// module id = 52
// module chunks = 0